import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BulkTaggingModal from 'components/modals/bulk_tagging_modal';

import { bulkTagging, endBulkTagging, setBulkTags } from "../../store/actions/people";

export class PeopleBulkTaggingModal extends React.Component {

  static propTypes = {
    bulkTags: PropTypes.array.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    startBulkTagging: PropTypes.bool.isRequired,
    tagsPaths: PropTypes.object.isRequired,
    onBulkTagging: PropTypes.func.isRequired,
    onCancelBulkTagging: PropTypes.func.isRequired,
    onSetBulkTags: PropTypes.func.isRequired,
  };


  render() {
    const {
      bulkTags,
      selectedPersonIds,
      startBulkTagging,
      tagsPaths,
      onBulkTagging,
      onCancelBulkTagging,
      onSetBulkTags
    } = this.props;

    const count = selectedPersonIds.length;

    return (
      <BulkTaggingModal
        buttonText={"Bulk Tag " + count + (count > 1 ? " Contacts" : " Contact")}
        paths={tagsPaths}
        selectedIds={selectedPersonIds}
        shown={startBulkTagging}
        tags={bulkTags}
        onBulkTag={onBulkTagging}
        onCancel={onCancelBulkTagging}
        onSetBulkTags={onSetBulkTags}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkTags: state.people.bulkTags,
  startBulkTagging: state.people.startBulkTagging,
  selectedPersonIds: state.selectList.selectedPersonIds,
  tagsPaths: state.paths.tags
});

const mapDispatchToProps = {
  onBulkTagging: bulkTagging,
  onCancelBulkTagging: endBulkTagging,
  onSetBulkTags: setBulkTags,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleBulkTaggingModal);
